import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { CompetitionIntensityModel } from "../../models/CompetitionIntensityModel";
import CompetitionIntensityService from "../../services/CompetitionIntensityService";
import CompetitionIntensitySlice from "../slices/CompetitionIntensitySlice";
import { RootState } from "../store";

export const CompetitionIntensityActions = CompetitionIntensitySlice.actions;
export const fetchCompetitionIntensities = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(
      CompetitionIntensityActions.setIsCompetitionIntensitiesFetching(true)
    );
    const response: CompetitionIntensityModel[] =
      await CompetitionIntensityService.getAllCompetitionIntensities();
    dispatch(CompetitionIntensityActions.setCompetitionIntensities(response));
    dispatch(
      CompetitionIntensityActions.setIsCompetitionIntensitiesFetching(false)
    );
  };
};
export const fetchParticularCompetitionIntensity = (
  CompetitionIntensity_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: CompetitionIntensityModel =
      await CompetitionIntensityService.getParticularCompetitionIntensity(
        CompetitionIntensity_id
      );
    dispatch(
      CompetitionIntensityActions.setParticularCompetitionIntensity(response)
    );
  };
};
